import React from 'react';
import { CalendarIcon } from 'lucide-react';
export function Schedule() {
  return <section id="horarios" className="w-full bg-[#111111] py-20 px-4 sm:px-6 lg:px-8" data-id="element-318">
      <div className="max-w-5xl mx-auto" data-id="element-319">
        {/* Header */}
        <div className="text-center mb-6" data-id="element-320">
          <h2 className="font-heading font-bold text-white uppercase text-3xl sm:text-4xl lg:text-5xl tracking-tight" data-id="element-321">
            Horarios
          </h2>
          <div className="section-divider" data-id="element-322" />
        </div>
        <p className="font-body text-gray-400 text-center mb-10" data-id="element-323">
          Selecciona tu horario en Calendly o revisa la tabla.
        </p>

        {/* Schedule Table */}
        <div className="overflow-x-auto mb-10" data-id="element-324">
          <table className="w-full border-collapse" data-id="element-325">
            <thead data-id="element-326">
              <tr className="bg-[#C9A84C]" data-id="element-327">
                <th className="font-heading font-bold text-black uppercase tracking-widest text-sm px-6 py-4 text-left" data-id="element-328">
                  Día
                </th>
                <th className="font-heading font-bold text-black uppercase tracking-widest text-sm px-6 py-4 text-left" data-id="element-329">
                  Horarios disponibles
                </th>
              </tr>
            </thead>
            <tbody data-id="element-330">
              <tr className="border-b border-[#2a2a2a] bg-[#1a1a1a]" data-id="element-331">
                <td className="font-heading font-bold text-white uppercase tracking-wide text-sm px-6 py-4" data-id="element-332">
                  Lunes – Viernes
                </td>
                <td className="font-body text-gray-300 text-sm px-6 py-4" data-id="element-333">
                  <div className="flex flex-wrap gap-2" data-id="element-334">
                    <span className="bg-[#0a0a0a] border border-[#2a2a2a] text-gray-300 px-3 py-1.5 text-xs font-body inline-flex items-center gap-2" data-id="element-335">
                      <span className="text-[#C9A84C] font-bold" data-id="element-336">10:00</span>
                      <span className="text-gray-500" data-id="element-337">—</span>
                      Kickboxing K1
                    </span>
                    <span className="bg-[#0a0a0a] border border-[#2a2a2a] text-gray-300 px-3 py-1.5 text-xs font-body inline-flex items-center gap-2" data-id="element-338">
                      <span className="text-[#C9A84C] font-bold" data-id="element-339">11:00</span>
                      <span className="text-gray-500" data-id="element-340">—</span>
                      MMA
                    </span>
                    <span className="bg-[#0a0a0a] border border-[#2a2a2a] text-gray-300 px-3 py-1.5 text-xs font-body inline-flex items-center gap-2" data-id="element-341">
                      <span className="text-[#C9A84C] font-bold" data-id="element-342">18:00</span>
                      <span className="text-gray-500" data-id="element-343">—</span>
                      MMA
                    </span>
                    <span className="bg-[#0a0a0a] border border-[#2a2a2a] text-gray-300 px-3 py-1.5 text-xs font-body inline-flex items-center gap-2" data-id="element-344">
                      <span className="text-[#C9A84C] font-bold" data-id="element-345">19:00</span>
                      <span className="text-gray-500" data-id="element-346">—</span>
                      Kickboxing K1
                    </span>
                  </div>
                </td>
              </tr>
              <tr className="border-b border-[#2a2a2a] bg-[#161616]" data-id="element-347">
                <td className="font-heading font-bold text-white uppercase tracking-wide text-sm px-6 py-4" data-id="element-348">
                  Sábado
                </td>
                <td className="font-body text-gray-300 text-sm px-6 py-4 italic" data-id="element-349">
                  Entrenamiento libre (consultar)
                </td>
              </tr>
              <tr className="bg-[#1a1a1a]" data-id="element-350">
                <td className="font-heading font-bold text-white uppercase tracking-wide text-sm px-6 py-4" data-id="element-351">
                  Domingo
                </td>
                <td className="font-body text-gray-500 text-sm px-6 py-4 italic" data-id="element-352">
                  Cerrado
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        {/* CTA */}
        <div className="text-center" data-id="element-353">
          <a href="#precios" className="inline-flex items-center gap-3 bg-[#C9A84C] hover:bg-[#E8C97A] text-black font-heading font-bold px-10 py-4 text-base tracking-widest uppercase transition-all duration-200 shadow-lg shadow-[#C9A84C]/25 hover:shadow-[#C9A84C]/40 hover:scale-105" data-id="element-354">
            <CalendarIcon size={18} data-id="element-355" />
            Ver Disponibilidad y Reservar
          </a>
        </div>
      </div>
    </section>;
}